import PropTypes from 'prop-types'
import React from "react"
import "./Style.scss"
import { Row, Col } from "reactstrap"
import LoginImg from "../../../assets/images/Faspro24_illustrations_login_1.png";
import MetaTagComp from "../../../components/Common/MetaTags";
import PropertyAgencyForm from "./Components/PropertyAgencyForm";
import Slide from "../../../components/Slide";

const PropertyAgency = () => {

    return (
        <React.Fragment>

            <MetaTagComp meta_tags="FASPRO 24 | property agency" />

            <div className="account-pages">
                <Row className="login">
                    <Col md={6} className="login-left">
                        <PropertyAgencyForm />
                    </Col>

                    <Col md={6} className="login-container">
                        <div className="login-img-container">
                            <Slide />
                        </div>
                    </Col>

                </Row>
            </div>
        </React.Fragment >
    )
}

export default PropertyAgency 